export default __webpack_public_path__ + "static/media/img.e84c0ad4.png";